import { render, staticRenderFns } from "./ImgZoomContent.vue?vue&type=template&id=40ad8968&scoped=true&"
import script from "./ImgZoomContent.vue?vue&type=script&lang=js&"
export * from "./ImgZoomContent.vue?vue&type=script&lang=js&"
import style0 from "./ImgZoomContent.vue?vue&type=style&index=0&id=40ad8968&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40ad8968",
  null
  
)

export default component.exports